import React, { useRef, useState, useCallback } from "react";
import { CustomDialog } from "../../../../../../common/components/dialogs";
import { translate } from "../../../../../../common/providers";
import PackageInfoForm from "./info/PackageInfoForm";
import styles from "./PackageCreationDialog.module.css";

export default function PackageCreationDialog({ open, onClose, onRefreshList, onUpdateRow, pck = null }) {
	const infoRef = useRef();
	const [submitDisabled, setSubmitDisabled] = useState(true);
	const isEditMode = !!pck;

	const handleSubmit = () => {
		if (infoRef.current?.submit) {
			infoRef.current.submit();
		}
	};

	const handleValidityChange = useCallback((isValid) => {
		setSubmitDisabled(!isValid);
	}, []);

	const title = isEditMode
		? translate("dsi.package-management.panel.info.edit-title")
		: translate("dsi.package-management.panel.creation.title");

	return (
		<CustomDialog
			className={styles.dialog}
			maxWidth={false}
			open={open}
			Paperprops={{ className: styles.dialogPaper }}
			submitDisabled={submitDisabled}
			title={title}
			onClose={onClose}
			onSubmit={handleSubmit}
		>
			<PackageInfoForm
				ref={infoRef}
				pck={pck}
				onClose={onClose}
				onRefreshList={onRefreshList}
				onUpdateRow={onUpdateRow}
				onValidityChange={handleValidityChange}
			/>
		</CustomDialog>
	);
}
